export default "__VITE_ASSET__ae835581__"